import { render, staticRenderFns } from "./home-foot.vue?vue&type=template&id=db5b49e0&scoped=true&"
var script = {}
import style0 from "./home-foot.vue?vue&type=style&index=0&id=db5b49e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5b49e0",
  null
  
)

export default component.exports